import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon } from 'antd-mobile';
import './index.less';
import Btn from 'Btn';
import cn from 'cn';
import en from 'en';
let popPwdQueue = [];

class LoginpopComponent extends Component {
  static props = {
    title: PropTypes.string,
    destroy: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
  };

  static defaultProps = {
    title: '',
    destroy: () => {},
    onConfirm: (destroy, toLogin) => {
      toLogin && toLogin();
      destroy && destroy();
    },
    onCancel: destroy => {
      destroy && destroy();
    },
  };

  state = {
    value: '',
  };

  onChange = e => {
    this.setState({ value: e.target.value });
  };

  render() {
    let lang = cn;
    let isEN = window.sessionStorage.getItem('language') == 'en';
    if (isEN) {
      lang = en;
    }
    if (window.sessionStorage.getItem('persist:emp')) {
      lang = JSON.parse(
        JSON.parse(window.sessionStorage.getItem('persist:emp')).App
      ).lang;
    }
    const { onCancel, onConfirm, destroy, toLogin } = this.props;
    const { value } = this.state;
    return (
      <section className="loginPop">
        <div
          id="lctct"
          className="login-content"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
        >
          <p className="popUP_title">{lang.reminder1}</p>
          <p>{lang.transportation5}</p>
          <div className="pop-btns">
            <Btn text={lang.login} onClick={e => onConfirm(destroy, toLogin)} />
          </div>
        </div>
      </section>
    );
  }
}

function renderLoginPop(props) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  let timeoutEvn = null;
  function keydownFun(e) {
    let dom = document.getElementById('lctct');
    const focusableElements = dom.getElementsByTagName('*');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];
    let isTabPressed =
      e.key === 'Tab' || (e.shiftKey && e.key === 'Tab') || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  const destroy = () => {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  ReactDOM.render(
    <LoginpopComponent {...props} destroy={destroy} toLogin={props.toLogin} />,
    div
  );

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('lctct').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(() => {
    focus();
    trapFocus();
  }, 200);
  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

export default function loginPopup(toLogin) {
  renderLoginPop({
    toLogin: toLogin,
  });
}

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };



// WEBPACK FOOTER //
// ./src/components/LoginPopup/index.js